export const profileData = {
  name: "Layton Pace",
  title: "Supply Chain & Logistics Professional",
  tagline: "Where data meets the dock — driving efficiency, growing accounts, and solving problems to keep freight moving on time, every time.",
  email: "wheelslp@gmail.com",
  phone: "(479) 422-7742",
  linkedin: "https://www.linkedin.com/in/lpace1",
  location: "Northwest Arkansas",
  availability: "Open to Remote, Hybrid, and On-Site Roles",
  summary: "Supply chain, logistics, and customer account management professional with 10+ years of experience across transportation operations, fleet coordination, pricing support, customer success, data reporting, and process improvement. Proven record supporting high-volume customer accounts, improving service performance, coaching independent contractors, analyzing operational data, resolving transportation issues, and creating reporting tools that improve visibility and efficiency. Targeting supply chain analytics, logistics operations, pricing, account management, customer success, and sales operations roles.",
};

export const experienceData = [
  {
    id: 1,
    role: "Capacity Coordinator",
    company: "J.B. Hunt Transport Services",
    companyLocation: "Northwest Arkansas",
    period: "02/2024 – Present",
    current: true,
    description: "Coordinate fleet and capacity operations for 35-40 independent contractors running nationwide freight across 360 Box and Brokerage, supporting service execution, safety, compliance, driver performance, and customer delivery expectations.",
    highlights: [
      "Coordinate 450-550 monthly loads across a nationwide independent contractor fleet, balancing capacity, driver availability, equipment needs, service expectations, and customer requirements.",
      "Improved service performance from approximately 96% to 97.5-98% by proactively tracking ETAs, identifying at-risk loads, coaching drivers, and escalating service issues before failure.",
      "Coach 35-40 independent contractors on customer expectations, on-time pickup and delivery requirements, safety procedures, compliance standards, and operational performance.",
      "Support DOT/FMCSA and internal safety compliance, contributing to 0 DOT preventable collisions in 7 of 12 months through proactive communication and driver follow-up.",
      "Analyze load status, capacity availability, service risk, and fleet performance using Power BI, Excel, J.B. Hunt 360, FM2, EOM, Eagle, and internal transportation systems.",
      "Coordinate with customer service, regional service managers, equipment teams, planners, and drivers to resolve delivery issues, equipment constraints, appointment conflicts, and service disruptions.",
    ],
    projects: [
      { name: "Freight by state midyear and annual analysis", description: "Compiled and analyzed freight activity reports covering load volume, revenue distribution, and length of haul across key states. Used geographic heat maps and customer breakdowns to identify high-performing regions, inform network planning, and support strategic decision-making for operational efficiency." },
      { name: "Safety and service games", description: "Designed and ran daily interactive games centered on safety and on-time service, providing independent contractors with an engaging way to reinforce proper procedures and the importance of both." },
      { name: "100% monthly and quarterly service certificates", description: "Created and distributed recognition certificates to independent contractors who achieved 100% on-time service for every load, acknowledging their hard work on a monthly and quarterly basis." },
      { name: "Created document with 100 safety messages", description: "Developed a comprehensive safety resource containing 100 messages across 10 truck driving safety categories, enabling a unique daily message to be sent to each driver to promote ongoing safety awareness." },
      { name: "Training documents for IC's", description: "Created onboarding training materials covering how to interpret various appointment time formats, strategies for avoiding service failures, and best practices to share with new independent contractors joining the team." },
      { name: "Fun committee leader", description: "Spearheaded the team's fun committee, planning and coordinating one in-office and one after-hours activity each month to foster team morale and build stronger workplace connections." },
    ],
    tags: ["Fleet Coordination", "Capacity Planning", "Load Planning", "DOT/FMCSA Compliance", "Power BI", "Service Recovery", "Driver Coaching", "Equipment Utilization", "ETA Tracking", "Safety Performance", "J.B. Hunt 360", "Stakeholder Communication"],
  },
  {
    id: 2,
    role: "Customer Experience Account Manager",
    company: "J.B. Hunt Transport Services",
    companyLocation: "Northwest Arkansas",
    period: "07/2021 – 02/2024",
    current: false,
    description: "Managed high-volume customer account operations for major enterprise accounts, serving as a key point of contact for service execution, reporting, issue resolution, pricing requests, and customer communication across dedicated and brokerage freight.",
    highlights: [
      "Supported 1-5 key customer accounts, including Lowe's, Medline, Southern Wine, Nike, Kimberly-Clark, and Georgia-Pacific, with responsibility for daily service visibility, issue resolution, and customer communication.",
      "Served as a primary point of contact for Lowe's transportation operations west of the Mississippi River, supporting approximately 400 loads per week during standard volume periods.",
      "Helped support Medline account expansion by improving service visibility, communication, reporting consistency, and operational follow-through as customer volume increased.",
      "Monitored on-time pickup, on-time delivery, tender acceptance, missed pickup trends, service failures, customer scorecards, and recurring operational issues to protect customer relationships.",
      "Created daily customer reporting to flag at-risk loads, communicate service exceptions, improve shipment visibility, and strengthen customer confidence during high-pressure operating periods.",
      "Processed 5-15 spot pricing requests per day depending on customer volume, often returning quotes within 5 minutes or less by using templates, pricing tools, and lane knowledge.",
    ],
    projects: [
      { name: "Fun Tuesdays initiative", description: "Shared weekly fun questions and interesting facts with customers and planners to build rapport and strengthen professional relationships beyond day-to-day operations." },
      { name: "Created macro to track load coverage and at-risk loads", description: "Built an Excel macro to automatically pull key load data, ensuring accurate communication with internal teams and customers while flagging at-risk loads in danger of missed pickups or late deliveries." },
      { name: "Created appointment setting documents for training new team members", description: "Developed reference and training documents for onboarding new team members and as an ongoing resource for the team to consult as needed." },
      { name: "Created automated reports for customer visibility", description: "Created automated reports sent to customers twice daily, providing real-time updates on load status and at-risk shipments to improve visibility and strengthen customer relationships." },
    ],
    tags: ["Enterprise Account Support", "Customer Scorecards", "Spot Pricing", "Service Visibility", "Escalation Management", "Tender Acceptance", "Shipment Tracking", "Customer Reporting", "Relationship Management", "Account Growth", "Contract Support", "Business Reviews"],
  },
  {
    id: 3,
    role: "Pricing Support Analyst",
    company: "J.B. Hunt Transport Services",
    companyLocation: "Northwest Arkansas",
    period: "02/2017 – 07/2021",
    current: false,
    description: "Prepared, validated, organized, and published customer pricing files for transportation bids, spot quotes, contract updates, and large-scale pricing projects while supporting pricing managers, sales, billing, and account teams.",
    highlights: [
      "Prepared and validated 10-20+ customer bid files per week, including large bid events with 1,000+ lanes, ensuring pricing data was accurate, complete, and formatted to customer requirements.",
      "Supported pricing strategy and bid execution by reviewing lane details, customer requirements, historical data, rate structures, accessorial information, and system publication rules.",
      "Used advanced Excel functions including VLOOKUP, pivot tables, IF statements, INDEX/MATCH, formulas, templates, and macros to organize pricing data and reduce manual errors.",
      "Built and maintained quote trackers to improve visibility into pricing requests, bid status, deadlines, customer requirements, and internal follow-up needs.",
      "Published rates in internal systems and converted pricing files between customer formats and internal platforms to support billing accuracy and operational execution.",
      "Automated customer authorization forms and recurring pricing processes using Excel macros and templates, saving an estimated 2+ hours per cycle and reducing repetitive manual work.",
      "Resolved pricing publication issues by validating data, identifying formatting errors, reconciling customer files, and coordinating corrections with pricing, billing, and sales teams.",
      "Worked with customer bid portals and external systems including Ryder, Bluejay, Transporeon, Coupa, and Microsoft Dynamics to support bid submissions and pricing updates.",
    ],
    tags: ["Bid Support", "Lane Analysis", "Rate Review", "Pricing Accuracy", "VLOOKUP & Pivot Tables", "Quote Tracking", "Excel Macros", "Pricing Publication", "Billing Accuracy", "Customer Bid Portals", "Process Automation", "Data Validation"],
  },
  {
    id: 4,
    role: "Trailer Utilization Specialist",
    company: "J.B. Hunt Transport Services",
    companyLocation: "Northwest Arkansas",
    period: "07/2015 – 02/2017",
    current: false,
    description: "Supported trailer utilization, equipment visibility, asset coordination, and operational communication to improve freight execution, reduce idle equipment, and maintain service reliability.",
    highlights: [
      "Monitored trailer availability, location, utilization, and movement to support network capacity, customer commitments, and efficient equipment use.",
      "Coordinated with operations, drivers, service teams, and equipment stakeholders to resolve trailer issues, yard constraints, equipment imbalances, and service-impacting delays.",
      "Used internal systems and reporting tools to validate trailer status, identify exceptions, update equipment information, and support timely operational decisions.",
      "Built an early-career logistics foundation in asset management, transportation execution, communication, and service recovery within a high-volume carrier environment.",
    ],
    tags: ["Asset Management", "Equipment Visibility", "Trailer Utilization", "Yard Management", "Service Recovery", "Network Capacity", "Operational Reporting", "Transportation Execution", "Equipment Coordination", "Stakeholder Communication"],
  },
];

export const educationData = [
  {
    id: 1,
    degree: "Master of Business Administration",
    field: "Supply Chain Management",
    school: "Southern Arkansas University",
    year: "May 2022",
    icon: "briefcase",
  },
  {
    id: 2,
    degree: "Master of Education",
    field: "Recreation and Sport Management",
    school: "University of Arkansas",
    year: "May 2015",
    icon: "graduation",
  },
  {
    id: 3,
    degree: "Bachelor of Science in Education",
    field: "Recreation and Sport Management",
    school: "University of Arkansas",
    year: "May 2013",
    icon: "book",
  },
];

export const skillsData = [
  {
    category: "Supply Chain & Logistics Operations",
    description: "Transportation operations, fleet coordination, capacity planning, load planning, tender management, pickup and delivery execution, service recovery, equipment utilization, freight operations",
    level: 95,
    icon: "truck",
  },
  {
    category: "Account Management & Customer Success",
    description: "Enterprise account support, customer scorecards, relationship management, escalation management, contract support, customer retention, account growth, service issue resolution",
    level: 93,
    icon: "trending-up",
  },
  {
    category: "Data Analytics & Reporting",
    description: "Power BI reporting, advanced Excel, KPI tracking, root cause analysis, operational analytics, scorecard analysis, trend analysis, forecasting support, reporting automation, basic SQL",
    level: 92,
    icon: "bar-chart",
  },
  {
    category: "Pricing, Revenue & Bid Support",
    description: "Spot pricing, bid support, lane analysis, rate review, quote tracking, pricing accuracy, pricing publication, revenue recovery, detention recovery, freight cost analysis",
    level: 90,
    icon: "dollar-sign",
  },
  {
    category: "Process Improvement & Leadership",
    description: "Excel macros, process automation, workflow improvement, template creation, error reduction, DOT/FMCSA compliance, safety performance, driver coaching, stakeholder communication",
    level: 91,
    icon: "settings",
  },
];

export const toolsData = [
  "Power BI", "Microsoft Excel", "Basic SQL", "Salesforce", "Microsoft Dynamics",
  "EDI", "J.B. Hunt 360", "FM2", "EOM", "Eagle", "Geotab", "Outlook",
  "Microsoft Teams", "PowerPoint", "Customer Bid Portals", "Internal Pricing Systems",
];

export const achievementsData = [
  "Improved transportation service performance from approximately 96% to 97.5-98% through proactive monitoring, communication, coaching, and service recovery.",
  "Supported approximately 450-550 monthly loads as Capacity Coordinator and approximately 400 weekly loads for Lowe's account operations.",
  "Helped support Medline account expansion through improved service execution, reporting visibility, and customer communication.",
  "Prepared 10-20+ weekly bid files and supported large pricing events with 1,000+ lanes.",
  "Automated pricing and customer authorization processes using Excel macros, saving an estimated 2+ hours per cycle.",
  "Returned many customer spot pricing quotes within 5 minutes or less, supporting faster customer response times and revenue opportunities.",
];

export const statsData = [
  { value: "10+", label: "Years Experience", numericValue: 10, maxValue: 15, color: "#0d9488" },
  { value: "~98%", label: "On-Time Performance", numericValue: 98, maxValue: 100, color: "#0f766e" },
  { value: "550+", label: "Monthly Loads", numericValue: 550, maxValue: 700, color: "#14b8a6" },
  { value: "<5min", label: "Quote Turnaround", numericValue: 5, maxValue: 30, color: "#2dd4bf" },
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Skills", href: "#skills" },
  { label: "Education", href: "#education" },
  { label: "Contact", href: "#contact" },
];
